import type { Variants } from 'framer-motion'

export const flip: Variants = {
  back: { rotateY: 0 },
  mid: {
    rotateY: 90,
    transition: { duration: 0.2, ease: 'linear' },
  },
  front: {
    rotateY: 0,
    transition: { duration: 0.2, delay: 0.2, ease: 'linear' },
  },
}
